(function () {
  'use strict';

  if (window.LbsCartBenefitsInitialized) {
    return;
  }

  window.LbsCartBenefitsInitialized = true;

  var GWP_PROPERTY = '_lbs_gwp';
  var isMutating = false;
  var refreshTimeouts = [];

  function getRootUrl() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getCartUrl() {
    return window.theme && window.theme.routes && window.theme.routes.cart_url
      ? window.theme.routes.cart_url
      : getRootUrl() + 'cart';
  }

  function getCartUpdateUrl() {
    return getRootUrl() + 'cart/update.js';
  }

  function getCartAddUrl() {
    return getRootUrl() + 'cart/add.js';
  }

  function requestJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error(text || 'Cart request failed.');
        });
      }

      return response.json();
    });
  }

  function getCart() {
    return fetch(getRootUrl() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to load the cart.');
      }

      return response.json();
    });
  }

  function isGwpItem(item) {
    return Boolean(item && item.properties && item.properties[GWP_PROPERTY] === 'true');
  }

  function hasNormalItem(cart) {
    return cart.items.some(function (item) {
      return !isGwpItem(item);
    });
  }

  function normaliseCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function collectCodeDiscounts(cart) {
    var codes = [];

    function addDiscount(discount) {
      if (!discount || discount.type !== 'discount_code' || !discount.title) {
        return;
      }

      var code = normaliseCode(discount.title);
      if (code && codes.indexOf(code) === -1) {
        codes.push(code);
      }
    }

    (cart.cart_level_discount_applications || []).forEach(addDiscount);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        addDiscount(allocation.discount_application);
      });
    });

    return codes;
  }

  function getVoucherElement() {
    return document.querySelector('[data-cart-benefit-voucher]');
  }

  function showVoucherMessage(message, isError) {
    var voucher = getVoucherElement();
    if (!voucher) {
      return;
    }

    var messageElement = voucher.querySelector('[data-voucher-message]');
    if (!messageElement) {
      return;
    }

    messageElement.textContent = message || '';
    messageElement.hidden = !message;
    messageElement.classList.toggle('is-error', Boolean(isError));
  }

  function showGwpMessage(message) {
    var section = document.querySelector('[data-cart-gwp]');
    if (!section) {
      return;
    }

    var messageElement = section.querySelector('[data-gwp-message]');
    if (!messageElement) {
      return;
    }

    messageElement.textContent = message || '';
    messageElement.hidden = !message;
  }

  function setBusy(elements, busy) {
    elements.forEach(function (element) {
      if (!element) {
        return;
      }

      element.disabled = busy;
      element.setAttribute('aria-busy', String(busy));
    });
  }

  function refreshHeader() {
    return fetch(getCartUrl()).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to refresh the cart header.');
      }

      return response.text();
    }).then(function (html) {
      var documentFragment = new DOMParser().parseFromString(html, 'text/html');
      var currentCartLink = document.querySelector('#site-control .cart:not(.nav-search)');
      var refreshedCartLink = documentFragment.querySelector('#site-control .cart:not(.nav-search)');

      if (currentCartLink && refreshedCartLink) {
        currentCartLink.replaceWith(refreshedCartLink);
      }
    });
  }

  function refreshGwpSection() {
    var section = document.querySelector('[data-cart-gwp][data-section-id]');
    if (!section) {
      return Promise.resolve();
    }

    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) {
      return Promise.resolve();
    }

    return fetch(getCartUrl() + '?section_id=' + encodeURIComponent(sectionId)).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to refresh gifts.');
      }

      return response.text();
    }).then(function (html) {
      var documentFragment = new DOMParser().parseFromString(html, 'text/html');
      var nextSection = Array.prototype.slice.call(documentFragment.querySelectorAll('[data-cart-gwp][data-section-id]')).find(function (candidate) {
        return candidate.getAttribute('data-section-id') === sectionId;
      });

      if (nextSection) {
        section.replaceWith(nextSection);
      }
    });
  }

  function notifyCartChanged() {
    document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
    document.dispatchEvent(new Event('cart:updated'));

    return refreshHeader().catch(function () {
      return undefined;
    });
  }

  function syncVoucherWithGwp() {
    var gwpSection = document.querySelector('[data-cart-gwp]');
    var voucher = document.querySelector('[data-cart-benefit-voucher]');
    if (!voucher) {
      return;
    }
    // Hide voucher (turn off discount code) when gift selector is visible.
    // Server also hides it via hide_voucher_when_gwp_eligible; this covers AJAX adds.
    var gwpVisible = Boolean(gwpSection && !gwpSection.hidden);
    voucher.style.display = gwpVisible ? 'none' : '';
  }

  function isGwpSectionEligible() {
    var section = document.querySelector('[data-cart-gwp]');
    if (!section) {
      return true;
    }
    if (section.hidden) {
      return false;
    }
    return section.getAttribute('data-eligible') === 'true';
  }

  function enforceGwpEligibility() {
    var section = document.querySelector('[data-cart-gwp][data-section-id]');
    if (!section || isMutating) {
      return Promise.resolve();
    }

    return getCart().then(function (cart) {
      var hasGwp = cart.items.some(isGwpItem);
      if (!hasGwp) {
        return;
      }

      var fresh = document.querySelector('[data-cart-gwp]');
      var eligible = fresh
        ? (fresh.getAttribute('data-eligible') === 'true' && !fresh.hidden)
        : isGwpSectionEligible();
      if (eligible) {
        return;
      }

      isMutating = true;
      return removeGwpItems(cart).then(function () {
        return notifyCartChanged();
      }).then(function () {
        return refreshGwpSection().catch(function () { return undefined; });
      }).then(function () {
        syncVoucherWithGwp();
      }).catch(function (error) {
        console.error('Unable to remove ineligible gift:', error);
      }).finally(function () {
        isMutating = false;
      });
    }).catch(function (error) {
      console.error('Unable to verify gift eligibility:', error);
    });
  }

  function refreshBenefitSurfaces() {
    refreshTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    if (typeof updateShippingProgressBarPopup === 'function') {
      updateShippingProgressBarPopup();
    }

    refreshTimeouts = [80, 750].map(function (delay) {
      return window.setTimeout(function () {
        if (typeof updateShippingProgressBarPopup === 'function') {
          updateShippingProgressBarPopup();
        }
        refreshGwpSection().then(function () {
          syncVoucherWithGwp();
          return enforceGwpEligibility();
        }).catch(function (error) {
          console.error('Unable to refresh gifts:', error);
        });
      }, delay);
    });
  }

  function removeGwpItems(cart) {
    var updates = {};

    cart.items.forEach(function (item) {
      if (isGwpItem(item)) {
        updates[item.key] = 0;
      }
    });

    return Object.keys(updates).length
      ? requestJson(getCartUpdateUrl(), { updates: updates })
      : Promise.resolve(cart);
  }

  function hasAppliedCode(cart, code) {
    return collectCodeDiscounts(cart).indexOf(normaliseCode(code)) !== -1;
  }

  function applyVoucher(form) {
    var input = form.querySelector('[name="discount"]');
    var submitButton = form.querySelector('[type="submit"]');
    var code = normaliseCode(input && input.value);

    if (!code) {
      showVoucherMessage(form.dataset.emptyMessage || 'Enter a voucher code.', true);
      if (input) {
        input.focus();
      }
      return;
    }

    isMutating = true;
    setBusy([input, submitButton], true);
    showVoucherMessage('', false);

    requestJson(getCartUpdateUrl(), { discount: code }).then(function (cart) {
      if (!hasAppliedCode(cart, code)) {
        throw new Error(form.dataset.invalidMessage || 'This voucher could not be applied.');
      }

      return removeGwpItems(cart);
    }).then(function () {
      return notifyCartChanged();
    }).catch(function (error) {
      showVoucherMessage(error.message || form.dataset.invalidMessage || 'This voucher could not be applied.', true);
    }).finally(function () {
      isMutating = false;
      setBusy([input, submitButton], false);
    });
  }

  function removeVoucher(button) {
    isMutating = true;
    setBusy([button], true);

    requestJson(getCartUpdateUrl(), { discount: '' }).then(function () {
      return notifyCartChanged();
    }).catch(function (error) {
      showVoucherMessage(error.message || 'Unable to remove the voucher.', true);
      setBusy([button], false);
    }).finally(function () {
      isMutating = false;
    });
  }

  function addGwp(form) {
    var button = form.querySelector('[data-gwp-add]');
    var variantInput = form.querySelector('[name="id"]');
    var variantId = Number(variantInput && variantInput.value);
    var productId = Number(form.dataset.gwpProductId);

    if (!variantId || !productId) {
      return;
    }

    // Server-rendered eligibility (min. purchase on non-SALE subtotal).
    // Section refreshes via ?section_id after cart changes, so dataset is fresh.
    // Discount codes are stripped below on add (GWP turns off discount code).
    var gwpSection = form.closest ? form.closest('[data-cart-gwp]') : null;
    if (gwpSection && gwpSection.getAttribute('data-eligible') !== 'true') {
      showGwpMessage(form.dataset.thresholdMessage || form.dataset.emptyCartMessage || 'Shop for min. purchase Rp 2.000.000 (excluding SALE items) to claim your gift.');
      return;
    }

    isMutating = true;
    setBusy([button, variantInput], true);

    var previousCodes = [];

    getCart().then(function (cart) {
      if (!hasNormalItem(cart)) {
        throw new Error(form.dataset.emptyCartMessage || 'Add another item to your cart before choosing a gift.');
      }

      if (cart.items.some(function (item) {
        return isGwpItem(item) && Number(item.product_id) === productId;
      })) {
        return cart;
      }

      previousCodes = collectCodeDiscounts(cart);
      return previousCodes.length
        ? requestJson(getCartUpdateUrl(), { discount: '' })
        : cart;
    }).then(function (cart) {
      if (cart.items.some(function (item) {
        return isGwpItem(item) && Number(item.product_id) === productId;
      })) {
        return cart;
      }

      return requestJson(getCartAddUrl(), {
        items: [{
          id: variantId,
          quantity: 1,
          properties: { _lbs_gwp: 'true' }
        }]
      });
    }).then(function () {
      return notifyCartChanged();
    }).catch(function (error) {
      var restore = previousCodes.length
        ? requestJson(getCartUpdateUrl(), { discount: previousCodes.join(',') }).catch(function () { return undefined; })
        : Promise.resolve();

      return restore.then(function () {
        showGwpMessage(error.message || form.dataset.errorMessage || 'Unable to add this gift.');
      });
    }).finally(function () {
      isMutating = false;
      setBusy([button, variantInput], false);
    });
  }

  function reconcileBeforeCheckout(form, submitter) {
    getCart().then(function (cart) {
      var hasGwp = cart.items.some(isGwpItem);
      var hasVoucher = collectCodeDiscounts(cart).length > 0;
      var eligible = isGwpSectionEligible();

      if (!hasGwp || (hasVoucher === false && eligible)) {
        form.requestSubmit(submitter);
        return;
      }

      isMutating = true;
      removeGwpItems(cart).then(function () {
        return notifyCartChanged();
      }).then(function () {
        isMutating = false;
        form.requestSubmit(submitter);
      }).catch(function (error) {
        isMutating = false;
        delete form.dataset.lbsCheckoutValidated;
        showVoucherMessage(error.message || 'Unable to update your cart before checkout.', true);
      });
    }).catch(function (error) {
      delete form.dataset.lbsCheckoutValidated;
      showVoucherMessage(error.message || 'Unable to verify your cart before checkout.', true);
    });
  }

  document.addEventListener('submit', function (event) {
    var voucherForm = event.submitter && event.submitter.closest('[data-voucher-form]');
    if (voucherForm) {
      event.preventDefault();
      if (!isMutating) {
        applyVoucher(voucherForm);
      }
      return;
    }

    var gwpForm = event.target.closest('[data-gwp-form]');
    if (gwpForm) {
      event.preventDefault();
      if (!isMutating) {
        addGwp(gwpForm);
      }
      return;
    }

    var isCheckout = event.submitter && event.submitter.name === 'checkout';
    if (!isCheckout || !event.target.matches('#cartform')) {
      return;
    }

    if (event.target.dataset.lbsCheckoutValidated === 'true') {
      delete event.target.dataset.lbsCheckoutValidated;
      return;
    }

    event.preventDefault();
    if (isMutating) {
      showVoucherMessage('Please wait while your cart is updating.', true);
      return;
    }

    event.target.dataset.lbsCheckoutValidated = 'true';
    reconcileBeforeCheckout(event.target, event.submitter);
  }, true);

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-voucher-remove]');
    if (removeButton) {
      event.preventDefault();
      if (!isMutating) {
        removeVoucher(removeButton);
      }
    }
  });

  document.addEventListener('theme:cartchanged', refreshBenefitSurfaces);
  document.addEventListener('cart:updated', refreshBenefitSurfaces);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncVoucherWithGwp();
      enforceGwpEligibility();
    });
  } else {
    syncVoucherWithGwp();
    enforceGwpEligibility();
  }
}());
